function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var DoubleSelector = /*#__PURE__*/function () {
  function DoubleSelector(form) {
    var _this = this;
    _classCallCheck(this, DoubleSelector);
    this.capacityValue = form.querySelector('.js-unit-capacity-value').value.replace(',', '.');
    this.inputQuantity = form.querySelector('.js-quantity__input');
    this.quantityButtons = form.querySelectorAll('.js-quantity__buttons');
    this.inputCapacity = form.querySelector('.js-unit-capacity__input');

    // use to break the reference with inputQuantity.value which is also used by integration-web-core--socle JS
    this.result = parseInt(this.inputQuantity.value);

    // init inputCapacity
    this.updateCapacity();

    // watch change on quantity input
    this.inputQuantity.addEventListener('keyup', function () {
      _this.inputQuantity.value = _this.inputQuantity.value.replace(/[^0-9]/g, '');
      _this.updateCapacity();
    });
    this.inputQuantity.addEventListener('QUANTITY_UPDATED', function () {
      _this.inputQuantity.value = _this.inputQuantity.value.replace(/[^0-9]/g, '');
      _this.updateCapacity();
    });

    // watch change on capacity input
    this.inputCapacity.addEventListener('keyup', function () {
      _this.inputCapacity.value = _this.inputCapacity.value.replace(/[^0-9,.]/g, '');
      _this.updateQuantity();
    });

    // update capacity on click on quantity buttons (plus and minus)
    this.quantityButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setTimeout(function () {
          return _this.inputCapacity.value = Math.round(parseInt(_this.inputQuantity.value) * _this.capacityValue * 100) / 100;
        }, 25);
      });
    });
  }

  /**
   * updateCapacity : update the capacity when quantity change
   */
  return _createClass(DoubleSelector, [{
    key: "updateCapacity",
    value: function updateCapacity() {
      try {
        this.inputQuantity.value = this.inputQuantity.value.replace(',', '.');
        this.inputCapacity.value = this.inputQuantity.value * this.capacityValue;
        this.inputCapacity.value = Math.round(this.inputCapacity.value * 100) / 100;
        this.result = parseInt(this.inputQuantity.value);
        this.updateButtons();
      } catch (error) {
        console.error('Error on updateQuantity', error);
      }
    }

    /**
     * updateQuantity : update the quantity when capacity change
     */
  }, {
    key: "updateQuantity",
    value: function updateQuantity() {
      try {
        this.inputCapacity.value = this.inputCapacity.value.replace(',', '.');
        this.inputQuantity.value = Math.ceil(this.inputCapacity.value / this.capacityValue);
        this.result = parseInt(this.inputQuantity.value);
        this.updateButtons();
      } catch (error) {
        console.error('Error on updateCapacity', error);
      }
    }
  }, {
    key: "updateButtons",
    value: function updateButtons() {
      var _this2 = this;
      this.quantityButtons.forEach(function (button) {
        if (button.classList.contains("js-quantity__button-minus")) {
          button.disabled = _this2.inputQuantity.value <= 1;
        }
      });
    }
  }]);
}();